<template lang="pug">
#CrearOT
    b-button(
        variant="action"
        @click="redirectToCreateOT()"

    )
        | Crear OT
</template>

<script>
export default {
    name: 'CrearOT',
    props: {
    dataOv: {
      type: Object,
      required: true
    }
  },
    methods: {
        redirectToCreateOT() {
            this.$router.push({
            name: 'Ingresar OT',
            params: { rut: this.dataOv.rut , n_serie: this.dataOv.numero_serie_equipo, ov_id: this.dataOv.id }
            })
        }
    }
}

</script>

